import {
    AlertConsumer,
    AlertConsumerType
} from "components/AlertContext";
import * as React from "react";

export default class SaleOrderAlert extends React.Component<any> {
    static contextType = AlertConsumer;

    constructor(props: any) {
        super(props);
    }
    render() {
        return (
            <>
                <AlertConsumer>
                    {(props: AlertConsumerType) => {
                        if (props.alert.open) {
                            return (
                                <div
                                    className={`alert ${props.alert.variants} alert-dismissible fade show`}
                                    role="alert"
                                >
                                    {props.alert.message}
                                    <button
                                        onClick={() =>
                                            props.setAlert({
                                                ...props.alert,
                                                open: false,
                                            })
                                        }
                                        type="button"
                                        className="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            );
                        } else {
                            null;
                        }
                    }}
                </AlertConsumer>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/quotes/SaleOrderAlert.tsx